import React from "react";
import "./App.css";
import "./data/publicDataCorrections";
import { SALAR_GRAPH_PREMIUM_IMAGE } from "./assets/salarGraphPremiumImage";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import VikkiAssistant from "./components/VikkiAssistant";
import MotionLayer from "./components/MotionLayer";
import Patent9SiteTextCleanup from "./components/Patent9SiteTextCleanup";
import PatentDemoDownloadBar from "./components/PatentDemoDownloadBar";
import MANILG1ReviewerGateway from "./components/MANILG1ReviewerGateway";
import MANILG1ProtectedReview from "./components/MANILG1ProtectedReview";
import PatentPortalGateway from "./components/PatentPortalGateway";
import PatentPortalWorkspace from "./components/PatentPortalWorkspace";

// Pages
import HomePatent9 from "./pages/HomePatent9";
import About from "./pages/About";
import MedicalScience from "./pages/MedicalScience";
import EnvironmentalResearch from "./pages/EnvironmentalResearch";
import VikrantSalar from "./pages/VikrantSalar";
import Capabilities from "./pages/Capabilities";
import Products from "./pages/Products";
import GPMIOneCable from "./pages/GPMIOneCable";
import GovernmentDefense from "./pages/GovernmentDefense";
import InternationalProcurement from "./pages/InternationalProcurement";
import PatentPortfolio9 from "./pages/PatentPortfolio9";
import MissionThread from "./pages/MissionThread";
import AIFabricAssurance from "./pages/AIFabricAssurance";
import Verify from "./pages/Verify";
import Publications from "./pages/Publications";
import Whitepapers from "./pages/Whitepapers";
import AISovereigntyReport from "./pages/AISovereigntyReport";
import AfterEndOfLife from "./pages/AfterEndOfLife";
import CBAEControlCell from "./pages/CBAEControlCell";
import Documents from "./pages/Documents";
import Resources from "./pages/Resources";
import Compliance from "./pages/Compliance";
import Contact from "./pages/Contact";
import UpdatesPatent9 from "./pages/UpdatesPatent9";
import NewsDetail from "./pages/NewsDetail";
import NotFound from "./pages/NotFound";
import ResilienceTerrain from "./pages/ResilienceTerrain";
import SalarGraph from "./pages/SalarGraph";
import QuantumSensingISR from "./pages/QuantumSensingISR";
import TotalSolutionArchitecture from "./pages/TotalSolutionArchitecture";
import Licensing from "./pages/Licensing";
import LicensingPatent from "./pages/LicensingPatent";
import LicensingRequest from "./pages/LicensingRequest";
import LicensingThankYou from "./pages/LicensingThankYou";
import SpectrumStrike from "./pages/SpectrumStrike";
import SpectrumStrikeDemo from "./pages/SpectrumStrikeDemo";
import InvestorRelations from "./pages/InvestorRelations";
import MediaInvestorRelations from "./pages/MediaInvestorRelations";
import PatentDemoHub from "./pages/PatentDemoHub";
import PatentDemoPage from "./pages/PatentDemoPage";
import PatentDemoBriefPageEnhanced from "./pages/PatentDemoBriefPageEnhanced";
import GBAMReviewerGateway from "./pages/GBAMReviewerGateway";
import GBAMProtectedReview from "./pages/GBAMProtectedReview";

const EngineeringReviewGate = React.lazy(
  () => import("./pages/EngineeringReviewGate"),
);
const EngineeringReviewProtected = React.lazy(
  () => import("./pages/EngineeringReviewProtected"),
);

const PRIVATE_REVIEW_PATHS = new Set([
  "/ukdi-manil-g1-preview",
  "/ukdi-manil-g1-review",
  "/restricted-patent-portfolio",
  "/restricted-patent-portfolio/workspace",
]);

function AppShell() {
  const location = useLocation();
  const isPrivateReview =
    PRIVATE_REVIEW_PATHS.has(location.pathname) ||
    location.pathname.startsWith("/engineering-review/");

  return (
    <>
      {!isPrivateReview ? <MotionLayer /> : null}
      {!isPrivateReview ? <Header /> : null}
      {!isPrivateReview ? <Patent9SiteTextCleanup /> : null}
      {!isPrivateReview ? <PatentDemoDownloadBar /> : null}
      <Routes>
        <Route path="/" element={<HomePatent9 />} />
        <Route path="/about" element={<About />} />
        <Route path="/environmental-research" element={<EnvironmentalResearch />} />
        <Route path="/engineering-advancement-medical-science" element={<MedicalScience />} />
        <Route path="/vikrant-salar" element={<VikrantSalar />} />
        <Route path="/capabilities" element={<Capabilities />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/gpmi-one-cable" element={<GPMIOneCable />} />
        <Route path="/government-defense" element={<GovernmentDefense />} />
        <Route
          path="/international-procurement"
          element={<InternationalProcurement />}
        />
        <Route path="/patent-portfolio" element={<PatentPortfolio9 />} />
        <Route path="/licensing" element={<Licensing />} />
        <Route path="/licensing/request" element={<LicensingRequest />} />
        <Route path="/licensing/thank-you" element={<LicensingThankYou />} />
        <Route path="/licensing/:slug" element={<LicensingPatent />} />
        <Route path="/mission-assurance" element={<MissionThread />} />
        <Route path="/ai-fabric-assurance" element={<AIFabricAssurance />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/whitepapers" element={<Whitepapers />} />
        <Route path="/ai-sovereignty-report" element={<AISovereigntyReport />} />
        <Route path="/after-the-end-of-life" element={<AfterEndOfLife />} />
        <Route path="/legacy-sustainment" element={<AfterEndOfLife />} />
        <Route
          path="/agent-containment-control-cell"
          element={<CBAEControlCell />}
        />
        <Route path="/documents" element={<Documents />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news-updates" element={<UpdatesPatent9 />} />
        <Route path="/news-updates/:id" element={<NewsDetail />} />
        <Route
          path="/salar-resilience-terrain"
          element={<ResilienceTerrain />}
        />
        <Route path="/salar-graph" element={<SalarGraph />} />
        <Route
          path="/quantum-sensing-for-isr"
          element={<QuantumSensingISR />}
        />
        <Route path="/Quantum-sensing-for-ISR" element={<QuantumSensingISR />} />
        <Route
          path="/total-solution-architecture"
          element={<TotalSolutionArchitecture />}
        />
        <Route path="/spectrum-strike" element={<SpectrumStrike />} />
        <Route path="/spectrum-strike-demo" element={<SpectrumStrikeDemo />} />
        <Route path="/investor-relations" element={<InvestorRelations />} />
        <Route path="/strategic-partners" element={<InvestorRelations />} />
        <Route
          path="/media-investor-relations"
          element={<MediaInvestorRelations />}
        />
        <Route path="/media-relations" element={<MediaInvestorRelations />} />
        <Route path="/patent-demos" element={<PatentDemoHub />} />
        <Route
          path="/patent-demos/:slug/brief"
          element={<PatentDemoBriefPageEnhanced />}
        />
        <Route path="/patent-demos/:slug" element={<PatentDemoPage />} />
        <Route
          path="/g-bam-mission-assurance-preview"
          element={<GBAMReviewerGateway />}
        />
        <Route
          path="/g-bam-mission-assurance-review"
          element={<GBAMProtectedReview />}
        />
        <Route
          path="/ukdi-manil-g1-preview"
          element={<MANILG1ReviewerGateway />}
        />
        <Route
          path="/ukdi-manil-g1-review"
          element={<MANILG1ProtectedReview />}
        />
        <Route path="/restricted-patent-portfolio" element={<PatentPortalGateway />} />
        <Route path="/restricted-patent-portfolio/workspace" element={<PatentPortalWorkspace />} />
        <Route
          path="/engineering-review/:slug"
          element={
            <React.Suspense
              fallback={<main aria-busy="true">Loading secure review…</main>}
            >
              <EngineeringReviewGate />
            </React.Suspense>
          }
        />
        <Route
          path="/engineering-review/:slug/workspace"
          element={
            <React.Suspense
              fallback={<main aria-busy="true">Loading secure review…</main>}
            >
              <EngineeringReviewProtected />
            </React.Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isPrivateReview ? <Footer /> : null}
      {!isPrivateReview ? <VikkiAssistant /> : null}
      {!isPrivateReview ? <Toaster /> : null}
    </>
  );
}

function App() {
  return (
    <div
      className="App"
      style={{
        "--salar-graph-premium-image": `url("${SALAR_GRAPH_PREMIUM_IMAGE}")`,
      }}
    >
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;

